export const validationPattern = {
  LOWERCASE_CHAR: 'Password must contain a lower case letter',
  UPPERCASE_CHAR: 'Password must contain an upper case letter',
  ONE_NUMBER: 'Password must contain a number',
  PASSWORD_LENGTH: 'Password must contain at least 8 characters',
  REQUIRED: 'This field is required'
};